<div class="simplified-container">
  <div class="flex justify-center">
    <div class="account-container">
      <div class="flex payment">
        <form [formGroup]="accountSelectionFormGroup">
          <div class="payment-account">
            <!-- Account and payment selection -->
            <div class="flex subheading">
              <div class="plusSign" data-cy="accountSelectionStepOne">{{ 1 }}</div>
              <span
                data-cy="selectionSubHeading"
                class="textHeading"
                dsContent
                [contentPath]="'billing.phoenixPayment.selectionSubHeading'"
              ></span>
            </div>
            <div>
              <amfam-simplified-payment-checkbox
                [controlName]="'option'"
                [parentFormGroup]="accountSelectionFormGroup"
                [billAccountOptions]="billAccountOptionFiltered"
                (checkBoxClickEvent)="handleCheckBoxInteraction()"
                (updateAccountEvent)="updateAccountEvent($event)"
              ></amfam-simplified-payment-checkbox>
            </div>
          </div>
        </form>
        <div class="paymentDateWrapper">
          <span
            class="paymentDate"
            dsContent
            [contentPath]="'billing.phoenixPayment.paymentDate'"
          ></span>
          <span style="margin-left: 8px">{{
            this.paymentDateValue | dateFormat: 'MMM DD, YYYY'
          }}</span>
        </div>
        <div class="flex subheading" style="margin-top: 24px">
          <div class="plusSign" data-cy="accountSelectionStepOne">{{ 2 }}</div>
          <h3
            data-cy="paymentMethod"
            dsContent
            [contentPath]="'billing.phoenixPayment.paymentMethod'"
          ></h3>
        </div>
        <div style="margin-top: 24px" class="paymentDateWrapper">
          @if (iframeToken === null && paymentMethods.length === 0) {
            <div style="width: 100%">
              <ds-add-payment-method-quicklinks
                [authorizedToAddPaymentMethod]="true"
                (addCheckingAccountEvent)="addCheckingAccount()"
                (addCreditDebitEvent)="addCreditDebit()"
                [newBillingDesign]="true"
                [isHSPolicy]="true"
                [hideHeading]="true"
              />
            </div>
          } @else {
            @if (paymentMethods.length > 0) {
              <form [formGroup]="paymentMethodFormGroup" style="width: 100%">
                <ds-payment-method
                  [formGroup]="paymentMethodFormGroup"
                  [paymentMethodOptions]="paymentMethodOptions"
                  [control]="'paymentMethod'"
                  [authorizedToAddPaymentMethod]="true"
                  [authorizedToEditPaymentMethod]="false"
                  [hideAddLink]="true"
                ></ds-payment-method>
              </form>
            } @else {
              @if (tokenType === 'CC') {
                <div>
                  <div style="display: inline-block">
                    <p
                      class="paymentDetailsHeader"
                      dsContent
                      [contentPath]="'billing.HSPayment.cardNumber'"
                    ></p>
                    <p
                      class="paymentDetailsHeader"
                      dsContent
                      [contentPath]="'billing.HSPayment.expirationDate'"
                    ></p>
                  </div>
                  <div style="display: inline-block; margin-left: var(--spacing-spacing-4)">
                    <p class="paymentDetailsData">{{ cardType }} {{ lastFour }}</p>
                    <p class="paymentDetailsData">{{ cardExpiry }}</p>
                  </div>
                </div>
              } @else if (tokenType === 'ACH') {
                <div>
                  <div style="display: inline-block">
                    <p
                      class="paymentDetailsHeader"
                      dsContent
                      [contentPath]="'billing.HSPayment.checkingAccount'"
                    ></p>
                    <p
                      class="paymentDetailsHeader"
                      dsContent
                      [contentPath]="'billing.HSPayment.routingNumber'"
                    ></p>
                  </div>
                  <div style="display: inline-block; margin-left: var(--spacing-spacing-4)">
                    <p class="paymentDetailsData">{{ checkingAccount }}</p>
                    <p class="paymentDetailsData">{{ routingNumber }}</p>
                  </div>
                </div>
              }
            }
          }
        </div>
        <div class="ctaContainer">
          <call-to-action
            [fullWidthButtons]="true"
            [primaryButtonName]="'Review payment ' + ((total$ | async).sum | currencyUSD)"
            [showPrimaryButton]="true"
            [disablePrimaryButton]="!valid"
            (primaryEvent)="gotoReview()"
            [secondaryButtonName]="secondaryButtonName"
            (secondaryEvent)="cancel()"
            style="width: 100%"
          ></call-to-action>
        </div>
      </div>
    </div>
  </div>
</div>
